var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lockMessage)?_c('div',{staticClass:"field is-flex is-align-content-center mt-1"},[_c('i',{staticClass:"fa-solid fa-info-circle"}),_vm._v(" "),_c('span',{staticClass:"is-size-7 is-capitalized has-text-weight-normal ml-1"},[_vm._v(_vm._s(_vm.lockMessage))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }